import React from "react";
import { useAppMeta } from "./useAppMeta";

export const useDocumentTitle = (title) => {
  const { appMeta } = useAppMeta();

  const titlePrefix = appMeta.title;

  React.useEffect(() => {
    document.title = !title ? titlePrefix : `${titlePrefix} | ${title}`;
  }, [title, titlePrefix]);
};
